// --
import React from 'react';
import InfiniteScrollExternal from 'react-infinite-scroller';
import classNames from 'classnames';
import Loader from "../loader/Loader";

/**
 * Komkponenta pro nekonečný scroll - jedná se o wrapper, který doplňuje některé vlastnosti externí InfiniteScroll komponentě.
 */
export default class InfiniteScroll extends React.Component {
    static PropTypes = {
        initialLoad: React.PropTypes.bool,
        threshold: React.PropTypes.number,
        pageStart: React.PropTypes.number,
        loader: React.PropTypes.element,
        useWindow: React.PropTypes.bool,
        loadMore: React.PropTypes.func.isRequired,
        hasMore: React.PropTypes.bool.isRequired,
        bordered: React.PropTypes.bool,   // pokud je true, jsou položky zobrazeny s okrajem, standardně je false
    };

    static defaultProps = {
        initialLoad: true,
        threshold: 6,
        pageStart: 0,
        loader: <Loader/>,
        useWindow: false,
        bordered: false
    };

    render() {
        const {className, children, bordered, ...other} = this.props;

        const cls = classNames(
            "items-list",
            className, {
                bordered
            }
        );

        return <InfiniteScrollExternal className={cls} {...other}>
            {this.props.children}
        </InfiniteScrollExternal>
    }
};
